var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 199,
    viewBox: "0 0 338 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.164 66.96V51.2357H162.428L167.438 39.5738L159.04 28.3262L177.966 10.1484L187.064 19.771L199.93 14.2269V0.796631H226.188V13.5418L238.292 19.3727L248.916 10.9609L266.379 28.0554L257.854 36.7221L262.053 50.9648L276.939 51.2357V77.1243L262.594 77.6819L257.043 89.2004L265.027 98.6955L264.9 109.672L149.164 127.101V66.96Z",
    fill: "#DBFFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.163 66.96V51.2357H152.428L157.437 39.5738L149.04 28.3262L167.966 10.1484L177.063 19.771L189.93 14.2269V0.796631H216.188V13.5418L228.291 19.3727L238.916 10.9609L256.379 28.0554L247.854 36.7221L252.053 50.9648L266.939 51.2357V77.1243L252.593 77.6819L247.043 89.2004L255.027 98.6955L254.9 109.672L139.163 127.101V66.96Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6777 117.941C26.1912 117.941 29.0394 115.088 29.0394 111.568C29.0394 108.049 26.1912 105.196 22.6777 105.196C19.1642 105.196 16.3159 108.049 16.3159 111.568C16.3159 115.088 19.1642 117.941 22.6777 117.941Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3845 147.239V198.219H120.953V170.005H134.153V198.219H202.574",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202 151L83 151.56V158H202V151Z",
    fill: "#DBFFF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264 139L203 139.48V145H264V139Z",
    fill: "#DBFFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.953 135.226V198.219H201.795L203.019 135.226H265.953Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.806 102.487H301.181V198.219H279.806",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312.553 147.223H338",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M312.553 154.551H325.276",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5422 64.5225H36.4211V150.345H57.5422",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0394 92.4503L2.86279 113.336",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15716 100.184C12.6707 100.184 15.5189 97.3313 15.5189 93.8118C15.5189 90.2923 12.6707 87.4392 9.15716 87.4392C5.64366 87.4392 2.79541 90.2923 2.79541 93.8118C2.79541 97.3313 5.64366 100.184 9.15716 100.184Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.365 102.487H254.55L276.482 138.492H201.365V102.487Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.289 197.55V162.501H219.48V197.55",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9814 198.203H57.542",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9216 198.203H81.0964",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M225.254 108.589H242.447L256.92 131.371H237.977L225.254 109.258",
    fill: "#D9D9D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.254 108.589H242.447L256.92 131.371H237.977L225.254 109.258",
    fill: "url(#paint0_linear_1286_384)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M225.254 108.589H242.447L256.92 131.371H237.977L225.254 109.258",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.626 108.589H213.819L228.292 131.371H209.349L196.626 109.258",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.626 108.589H213.819L228.292 131.371H209.349L196.626 109.258",
    fill: "url(#paint1_linear_1286_384)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.626 108.589H213.819L228.292 131.371H209.349L196.626 109.258",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214.385 93.9638C231.233 93.9638 244.89 80.2832 244.89 63.4073C244.89 46.5313 231.233 32.8507 214.385 32.8507C197.538 32.8507 183.881 46.5313 183.881 63.4073C183.881 80.2832 197.538 93.9638 214.385 93.9638Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.385 93.9638C220.233 93.9638 233.89 80.2832 233.89 63.4073C233.89 46.5313 220.233 32.8507 203.385 32.8507C186.538 32.8507 172.881 46.5313 172.881 63.4073C172.881 80.2832 186.538 93.9638 203.385 93.9638Z",
    fill: "#FFFCFC",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9221 151.508L131.514 64.5225H203.386L202.781 150.552L64.9221 151.508Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M123.323 90.8253L139.036 70.4808H158.519L143.632 90.8253H123.323Z",
    fill: "#D9D9D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.323 90.8253L139.036 70.4808H158.519L143.632 90.8253H123.323Z",
    fill: "url(#paint2_linear_1286_384)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M123.323 90.8253L139.036 70.4808H158.519L143.632 90.8253H123.323Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.36 90.8253L166.074 70.4808H185.557L170.67 90.8253H150.36Z",
    fill: "#D9D9D9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.36 90.8253L166.074 70.4808H185.557L170.67 90.8253H150.36Z",
    fill: "url(#paint3_linear_1286_384)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.36 90.8253L166.074 70.4808H185.557L170.67 90.8253H150.36Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.253 120.458L143.966 100.113H163.449L148.563 120.458H128.253Z",
    fill: "#D9D9D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M128.253 120.458L143.966 100.113H163.449L148.563 120.458H128.253Z",
    fill: "url(#paint4_linear_1286_384)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.253 120.458L143.966 100.113H163.449L148.563 120.458H128.253Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M155.291 120.458L171.004 100.113H190.487L175.6 120.458H155.291Z",
    fill: "#D9D9D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.291 120.458L171.004 100.113H190.487L175.6 120.458H155.291Z",
    fill: "url(#paint5_linear_1286_384)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M155.291 120.458L171.004 100.113H190.487L175.6 120.458H155.291Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.216 120.458L116.929 100.113H136.412L121.525 120.458H101.216Z",
    fill: "#D9D9D9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M101.216 120.458L116.929 100.113H136.412L121.525 120.458H101.216Z",
    fill: "url(#paint6_linear_1286_384)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M101.216 120.458L116.929 100.113H136.412L121.525 120.458H101.216Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1286_384",
    x1: 229.533,
    y1: 122.891,
    x2: 255.76,
    y2: 137.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1286_384",
    x1: 200.905,
    y1: 122.891,
    x2: 227.132,
    y2: 137.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1286_384",
    x1: 128.079,
    y1: 83.2531,
    x2: 153.917,
    y2: 101.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1286_384",
    x1: 155.116,
    y1: 83.2531,
    x2: 180.955,
    y2: 101.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1286_384",
    x1: 133.009,
    y1: 112.886,
    x2: 158.847,
    y2: 130.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1286_384",
    x1: 160.047,
    y1: 112.886,
    x2: 185.885,
    y2: 130.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1286_384",
    x1: 105.972,
    y1: 112.886,
    x2: 131.81,
    y2: 130.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse2);
export default __webpack_public_path__ + "static/media/House 2.949dec61f281998031356b351a0188dd.svg";
export { ForwardRef as ReactComponent };